import { render, staticRenderFns } from "./Bbs.vue?vue&type=template&id=2efa99d8&scoped=true&"
import script from "./Bbs.vue?vue&type=script&lang=js&"
export * from "./Bbs.vue?vue&type=script&lang=js&"
import style0 from "./Bbs.vue?vue&type=style&index=0&id=2efa99d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa99d8",
  null
  
)

export default component.exports